module.exports = __webpack_public_path__ + "static/Vent-06166077c9654195086c20d23fe22618.jpg";